/* import __COLOCATED_TEMPLATE__ from './restricted.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();